<mat-accordion>
  <ng-container *ngFor="let level of levels; let i = index">
    <mat-expansion-panel
      [expanded]="expandLevelInProgress(level?.levelId)"
      [disabled]="level?.locked"
      hideToggle
      (opened)="setOpened(i, level)"
      (closed)="setClosed(i)">
      <mat-expansion-panel-header tabindex="0" collapsedHeight="76px" expandedHeight="76px">
        <div class="level-card__header">
          <div class="level-card__header__left">
            <div class="level-card__header__left__title">{{ level.name }}</div>
            <div class="level-card__header__left__subtitle">
              {{ level.resourcesTotal }} {{ 'careerPlans.lessons' | translate }}
            </div>
          </div>
          <div class="level-card__header__right">
            <ng-container *ngIf="level?.locked; else unlocked">
              <span aria-hidden="true" class="odilo-icon">lock</span>
            </ng-container>
            <ng-template #unlocked>
              <ng-container *ngIf="level.resourcesCompleted > 0">
                <div
                  class="level-card__header__right__status"
                  *ngIf="level.resourcesCompleted === level.resourcesTotal">
                  <span class="level-card__header__right__status__label"
                    >{{ 'careerPlans.status.completed' | translate }}</span
                  >
                  <span class="career-plan-resource-status career-plan-resource-status--completed"></span>
                </div>
              </ng-container>
              <app-circle-arrow-button
                [enableToggle]="true"
                [unfolded]="expandContentByIndex(i)"></app-circle-arrow-button>
            </ng-template>
          </div>
        </div>
      </mat-expansion-panel-header>

      <div class="level-card__body" *ngIf="isOpen && !level?.locked">
        <div class="level-card__body__description">{{ 'careerPlans.level.description' | translate }}</div>

        <div class="container-resources">
          <div class="resources">
            <ng-container *ngFor="let resource of level.resourcesObligatory; let last = last">
              <app-resource-card [resource]="resource"></app-resource-card>
              <app-resource-separator *ngIf="!last"></app-resource-separator>
            </ng-container>

            <ng-container *ngIf="level.complementaryResourcesProgress">
              <app-resource-separator></app-resource-separator>
              <app-complementary-resource-card
                [resource]="level.complementaryResourcesProgress"
                [levelId]="level.levelId"></app-complementary-resource-card>
            </ng-container>
            <app-resource-separator class="last-separator" *ngIf="level.resourcesOptional?.length"></app-resource-separator>
          </div>

          <div class="carousel" *ngIf="level.resourcesOptional?.length">
            <resource-carousel
              [records]="level.resourcesOptional"
              [resourcesOptionalCriteria]="level.resourcesOptionalCriteria"
              [optionalResourcesQuery]="level.optionalResourcesQuery"
              [levelName]="level.name"></resource-carousel>
          </div>
        </div>
      </div>
    </mat-expansion-panel>
  </ng-container>
</mat-accordion>
